import { ChangeDetectorRef, inject, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { localizeRequirementLabel } from './requirement-label';

@Pipe({ name: 'requirementTypeLabel', standalone: true, pure: false })
export class RequirementTypeLabelPipe implements PipeTransform, OnDestroy {
  private translate = inject(TranslateService);
  private cdr = inject(ChangeDetectorRef);
  private sub: Subscription;

  constructor() {
    this.sub = this.translate.onLangChange.subscribe(() => this.cdr.markForCheck());
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  // NEX-1018 Review (fboudouhi): die Key-Tabelle ist bewusst nur fuer die
  // sieben Default-Typen gefuellt. Projekt-lokal angelegte oder per Import
  // uebernommene Typen wandern verbatim durch den Rohwert-Fallback — bilinguale
  // Anzeige kommt erst mit einem stabilen Katalog-Code (NEX-1077).
  transform(value: string | null | undefined): string {
    return localizeRequirementLabel('type', value, this.translate);
  }
}
